import { toast } from "react-toastify";

/**
 * Show a toast notification
 * @param {string} message - The message to show
 * @param {"success" | "error"} type - The type of toast
 * @param {number} [autoClose=2500] - Time in ms before auto-dismiss (default 2500ms)
 */
export function showToast(message, type = "success", autoClose = 2500) {
	const config = {
		position: "top-right",
		autoClose,
		hideProgressBar: false,
		closeOnClick: true,
		// pauseOnHover: true,
		draggable: true,
		progress: undefined,
	};

	if (type === "success") {
		toast.success(message, config);
	} else if (type === "error") {
		toast.error(message, config);
	} else {
		console.warn("Invalid toast type. Use 'success' or 'error'.");
	}
}
